import { SPFIELD } from '../actionTypes';

const initialState = {
  selectedUser: {},
  content: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SPFIELD.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case SPFIELD.SELECTED:
      return {
        ...state,
        selectedUser: action.payload,
      };
    default:
      return state;
  }
};
